<template>
    <div id="body">
        <div id="portfolio-feature-wrap">
            <div id="portfolio-feature">
                <div id="frame" class="frame frame-accolade">
                    <Header :mobile="platform.mobile" @sub-navigation-navigate="$emit('sub-navigation-navigate', $event)"/>
                    <div class="content-secondary" v-if="accolade && accolade.AccoladeSourceDetails">
                        <div id="accolade-detail" class="flex gap-50 layout-70-30 m-row">
                            <div class="layout m-span">
                                <div id="heading">
                                    <h1 class="no-margin-b">{{ accolade.Granter }}</h1>
                                    <h2>{{ accolade.Title }}</h2>
                                </div>
                                <div id="description">
                                    <p v-for="(paragraph, p) in Description()" :key="p" v-html="paragraph"></p>
                                </div>
                                <Button
                                    :type="BUTTON_TYPES.off"
                                    value="Back"
                                    position="left"
                                    @click="NavigateBack()"
                                />
                            </div>

                            <!-- Feature media -->
                            <div id="feature-media-wrap" class="align-c layout m-span single">
                                <div id="feature-media" class="btn m-span right single w-85">
                                    <p v-if="FeatureMedia().url !== ''">
                                        <a :href="FeatureMedia().url" target="_blank" :aria-label="`View Accolade - ${MediaLabel()}`">
                                            <img class="span" :src="MediaSource(0)" :alt="`Accolade - ${MediaLabel()}`" :title="MediaLabel()"/>
                                        </a>
                                    </p>
                                    <p v-else>
                                        <img class="btn span" :src="MediaSource(0)" :alt="`Accolade - ${MediaLabel()}`" :title="MediaLabel()" @click="View(accolade.AccoladeSourceDetails.Media[0].Source)"/>
                                    </p>
                                    <div id="feature-media-labels" class="align-l flex">
                                        <p class="media-name">{{ FeatureMedia().name }}</p>
                                        <p id="label" class="flex-right table">Featured</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Gallery -->
                        <div id="accolade-gallery" v-if="gallery.length">
                            <h3 class="no-margin-b">More Media</h3>
                            <div id="gallery-media" class="flex gap-40 m-row">
                                <div class="gallery-media m-span single w-15" v-for="(media, m) in gallery" :key="m">
                                    <p v-if="media.URL">
                                        <a :href="media.URL" target="_blank" :aria-label="`View Accolade - ${MediaLabel()}`">
                                            <img class="span" :src="GallerySource(m)" :alt="`Accolade - ${media.Name}`" :title="media.Name"/>
                                        </a>
                                    </p>
                                    <p v-else>
                                        <img class="btn span" :src="GallerySource(m)" :alt="`Accolade - ${media.Name}`" :title="media.Name" @click="View(media.Source)"/>
                                    </p>
                                    <p class="media-name">{{ media.Name }}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Template/Header.vue";
import Button from "@/components/Button.vue";
import { viewModel } from "@/models";
import { READ } from "@/data/Read.js";
import DataAPI from "@/data/API.js";
import { BUTTON_TYPES } from "@/assets/JS/Assets.js";

export default {
    name: "AccoladeView",
    props: { ...viewModel.props },
    components: {
        Header,
        Button
    },
    data: () => ({
        ...viewModel.data,
        accolade: {},
        BUTTON_TYPES,
        gallery: []
    }),
    methods: {
        MediaSource: function(index) {
            const source = this.accolade.AccoladeSourceDetails.Media[index].Source;
            return require(`@/assets/Images/Accolades/${this.accolade.Type}/${this.accolade.AccoladeID}/${source}`);
        },
        GallerySource: function(index) {
            const source = this.gallery[index].Source;
            return require(`@/assets/Images/Accolades/${this.accolade.Type}/${this.accolade.AccoladeID}/${source}`);
        },
        MediaLabel: function() {
            const { Granter, Title } = this.accolade;
            return `${Granter} | ${Title}`;
        },
        Description: function() {
            if (this.accolade.Description) {
                return this.accolade.Description.split("|");
            }
            return [];
        },
        NavigateBack: function() { this.$router.push({ name: "Accolades" }); },
        FeatureMedia: function() {
            const media = this.accolade.AccoladeSourceDetails.Media;
            let name, url;
            name = "";
            url = "";
            if (media.length) {
                name = media[0].Name;
                url = media[0].URL;
            }
            return {
                name,
                url
            };
        },
        View: function(mediaSource) {
            const source = require(`@/assets/Images/Accolades/${this.accolade.Type}/${this.accolade.AccoladeID}/${mediaSource}`);
            window.open(source, "_blank");
        }
    },
    mounted: async function() {
        this.$emit("start-loader", "#app");
        const accoladeID = Number(this.$route.params.accoladeID);
        this.accolade = await READ.AccoladeByAccoladeID(this, DataAPI, accoladeID);

        // Prepare gallery
        let g = 0;
        for (const media of this.accolade.AccoladeSourceDetails.Media) {
            g++;
            if (g > 1) {
                this.gallery.push(media);
            }
        }

        window.scrollTo(0, 0);
        this.$emit("stop-loader");
    },
    emits: [ ...viewModel.emits ]
};
</script>